import { RenderUnsettledUI } from 'shared/components';
import { FlexWorkersTable } from 'shared/components/flex-workers-for-work-table/flex-workers-table';
import { FlexWorkersForShiftFilters } from 'shared/components/flex-workers-for-work-table/flex-workers-for-work.types';
import { DEFAULT_PAGE_SIZE } from 'shared/utils/constants';
import { useGetFlexWorkersForShiftPlanningOGP } from 'shared/components/shift-detail-modal/query-hooks/ogp/use-get-flex-workers-for-shift-planning-ogp';
import { FlexWorkerTableOptions } from '../../../../flex-workers-for-work-table/flex-workers-for-work-table.types';

type ProviderProps = {
  shiftId: string;
  getRowActions: FlexWorkerTableOptions['getRowActions'];
  isShiftInFuture?: boolean;
  filters?: FlexWorkersForShiftFilters;
};

export const ShiftAddFlexWorkerTableProviderOGP = ({
  filters,
  shiftId,
  getRowActions,
  isShiftInFuture,
}: ProviderProps) => {
  if (isShiftInFuture) {
    filters = { ...filters, isEmployee: true, isFreelancer: false, isTempWorker: false };
  }

  const flexWorkerQuery = useGetFlexWorkersForShiftPlanningOGP(shiftId, DEFAULT_PAGE_SIZE, filters);
  const { status } = flexWorkerQuery;

  if (status !== 'success') {
    return <RenderUnsettledUI data={flexWorkerQuery} />;
  }

  return (
    <FlexWorkersTable
      queryResult={flexWorkerQuery}
      entityId={shiftId}
      getRowActions={getRowActions}
    />
  );
};
